import gsap from 'gsap'
import { CustomEase } from 'gsap/dist/CustomEase'
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin'
import { Observer } from 'gsap/dist/Observer'
import { ScrollSmoother } from 'gsap/dist/ScrollSmoother'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { SplitText } from 'gsap/dist/SplitText'

if (typeof window !== 'undefined') {
  gsap.registerPlugin(
    MotionPathPlugin,
    ScrollSmoother,
    ScrollTrigger,
    SplitText,
    CustomEase,
    Observer
  )

  CustomEase.create('inOut1', 'M0,0 C0.5,0 0.1,1 1,1', { precision: 2 })
  CustomEase.create('inOut2', 'M0,0 C0.56,0 0,1 1,1', { precision: 2 })
  CustomEase.create('inOut3', 'M0,0 C0.6,0 0,1 1,1', { precision: 2 })
  CustomEase.create('inOut4', 'M0,0 C0.4,0 -0.06,1 1,1', { precision: 2 })
}
